import { useEffect, useState } from "react";
import "./Datetime.css";
import { capitalize } from "../../utils/string";
import { useUserStore } from "../../contexts/userStore";
import { useTranslation } from "react-i18next";

export const LOCALES = {
   pt: "pt-BR",
   sp: "es-ES",
   en: "en-US"
}

export const Datetime = ({ className, ...props }) => {
   const [currentDate, setCurrentDate] = useState('');
   const [currentTime, setCurrentTime] = useState('');
   const { selectedCondominioObj, currentAddress } = useUserStore();
   const { t, i18n } = useTranslation();

   useEffect(() => {
      const updateDateTime = () => {
         const now = new Date();
         const timeZone = currentAddress?.timezone?.name || Intl.DateTimeFormat().resolvedOptions().timeZone;
         console.log(`--- Timezone: ${timeZone} ---`);
         const date = now.toLocaleDateString(LOCALES[i18n.language], { timeZone, weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
         const time = now.toLocaleTimeString(LOCALES[i18n.language], { timeZone, hour: '2-digit', minute: '2-digit' });
         setCurrentDate(date);
         setCurrentTime(time);
      };

      updateDateTime();
      const intervalId = setInterval(updateDateTime, 1000 * 30);

      return () => clearInterval(intervalId);
   }, [currentAddress, i18n.language]);

   return (
      <p {...props} className={`datetime ${className}`}>
         {currentAddress?.city && <b>{currentAddress.city}</b>}
         <span>{capitalize(currentDate)} {currentTime}</span>
      </p>
   );
}